import React, { useState } from 'react';
import PublicPage from '../PublicPage';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Box, Button, Container, FormControlLabel, Grid, TextField, Typography } from '@mui/material'
import validators from '../../utils/validators';
import { TextFieldComponent } from '../../components/CustomFormElement';
import { makeStyles } from '@mui/styles';
import { common } from '@mui/material/colors';

const useStyles = makeStyles((theme) => ({    
    button: {
        textTransform: 'capitalize!important',
        color: theme.palette.common.white + '!important'
    }
}));

export default function OTPView(props){
    const { t } = useTranslation();
    const {onResend, onLogin} = props;
    const classes = useStyles();
    return(
        <Grid xs={12} item >
            <Grid xs={12} item marginTop={5}>
                <Typography variant="h4" color="primary.contrastText">{t('verify_email')}</Typography>
            </Grid>
            <Grid marginBottom={10}>
                <Typography variant="subtitle1" style={{opacity: 0.6}} color="primary.contrastText">{t('verify_content1')} {t('verify_content2')}</Typography>
            </Grid>
            <Form
            onSubmit={onLogin}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item>
                    <Field
                        name="otp_code"
                        component={TextFieldComponent}
                        placeholder={t('verify_placeholder')}
                        isEdit={true}
                        
                        validate={validators.composeValidators(validators.mustBeNumber)}
                    />
                    <Grid xs={12} item container justify='center' marginTop={2}>
                        <Button variant="text" fullWidth onClick={onResend} className={classes.button}>
                            {t('verify_resendCode')}
                        </Button>
                    </Grid>
                    <Grid xs={12} item container justify='center' marginTop={5}>
                        <Button variant="contained" color="secondary" fullWidth onClick={handleSubmit} className={classes.button} >{t('btn_sign_in')}</Button>
                    </Grid>
                </Grid>
            )} />
        </Grid>
    );
}
